import type { AskReliFloatingChatContentProps } from "./AskReli.types";
import { AskReliCustomerChat } from "./AskReliCustomerChat";
import { AskReliFloatingCustomerSelectionFallback } from "./AskReliFloatingFallbackShell";

export function AskReliFloatingChatContent({
  externalCustomerId,
  contextLabel,
  isExpanded,
  userName,
  onClose,
  onToggleExpand,
}: AskReliFloatingChatContentProps) {
  if (!externalCustomerId) {
    return (
      <AskReliFloatingCustomerSelectionFallback
        isExpanded={isExpanded}
        onClose={onClose}
        onToggleExpand={onToggleExpand}
      />
    );
  }

  return (
    <AskReliCustomerChat
      contextLabel={contextLabel}
      externalCustomerId={externalCustomerId}
      isExpanded={isExpanded}
      userName={userName}
      onClose={onClose}
      onToggleExpand={onToggleExpand}
    />
  );
}
